import BookmarksPage from '../pages/Bookmarks';
import CirclesPage from '../pages/Circles';
import Dashboard from '../pages/Dashboard';
import DirectMessages from '../pages/DirectMessages';
import Drafts from '../pages/Drafts';
import Draft from '../pages/Drafts/Draft';
import PostReplyDraft from '../pages/Drafts/PostReplyDraft';
import RecommendationFeed from '../pages/Feed/recommendationFeed';
import FollowingFeedPage from '../pages/Following/index';
import UserInterests from '../pages/Interests';
import LikesPage from '../pages/Likes';
import ManualIndex from '../pages/Manual';
import ManualSectionRoute from '../pages/Manual/ManualSectionRoute';
import ModerationQueuePage from '../pages/Moderation/Queue';
import Posts from '../pages/Posts';
import EditRewrite from '../pages/Posts/Post/EditRewrite';
import Post from '../pages/Posts/Post/index';
import PostAnalysis from '../pages/Posts/PostAnalysis';
import PostHistory from '../pages/Posts/PostHistory';
import SentimentMapPage from '../pages/Posts/SentimentMap';
import UserProfileRoute from '../pages/Profile';
import PulsePage from '../pages/Pulse';
import Replies from '../pages/Replies';
import ReplyAnalysis from '../pages/Replies/ReplyAnalysis';
import Reply from '../pages/Replies/reply';
import ReputationBreakdown from '../pages/Reputation/ReputationBreakdown';
import SearchPage from '../pages/Search';
import Settings from '../pages/Settings';
import SharedPage from '../pages/Shared';
import Stories from '../pages/Stories';
import VouchPage from '../pages/Vouch';
import { PRIVATE_URIS } from './privateURIs.constants';

const {
  DASHBOARD,
  DIRECT_MESSAGES,
  FEED,
  INTERESTS,
  POST,
  POSTS,
  PROFILE,
  DRAFTS,
  DRAFT,
  POST_REPLY_DRAFT,
  REPLIES,
  REPLY,
  SEARCH,
  SETTINGS,
  STORIES,
  LIKES,
  BOOKMARKED,
  FOLLOWING,
  SHARED,
  CIRCLES,
  MODERATION_QUEUE,
  POST_EDIT_REWRITE,
  POST_ANALYSIS,
  REPLY_ANALYSIS,
  POST_HISTORY,
  POST_SENTIMENT,
  PULSE,
  REPUTATION,
  VOUCH,
  README,
  README_SECTION,
} = PRIVATE_URIS;

export const PRIVATE_ROUTES = [
  {
    name: 'Dashboard',
    uri: DASHBOARD,
    Component: Dashboard,
  },
  {
    name: 'Direct Messages',
    uri: DIRECT_MESSAGES,
    Component: DirectMessages,
  },
  {
    name: 'Feed',
    uri: FEED,
    Component: RecommendationFeed,
  },
  {
    name: 'Interests',
    uri: INTERESTS,
    Component: UserInterests,
  },
  {
    name: 'Drafts',
    uri: DRAFTS,
    Component: Drafts,
  },
  {
    name: 'Draft',
    uri: DRAFT,
    Component: Draft,
  },
  {
    name: 'Post Reply Draft',
    uri: POST_REPLY_DRAFT,
    Component: PostReplyDraft,
  },
  {
    name: 'Posts',
    uri: POSTS,
    Component: Posts,
  },
  {
    name: 'Post',
    uri: POST,
    Component: Post,
  },
  {
    name: 'Profile',
    uri: PROFILE,
    Component: UserProfileRoute,
  },
  {
    name: 'Replies',
    uri: REPLIES,
    Component: Replies,
  },
  {
    name: 'Reply',
    uri: REPLY,
    Component: Reply,
  },
  {
    name: 'Settings',
    uri: SETTINGS,
    Component: Settings,
  },
  {
    name: 'Stories',
    uri: STORIES,
    Component: Stories,
  },
  {
    name: 'User Interaction Feed - Likes',
    uri: LIKES,
    Component: LikesPage,
  },
  {
    name: 'User Interaction Feed - Bookmarks',
    uri: BOOKMARKED,
    Component: BookmarksPage,
  },
  {
    name: 'Shared',
    uri: SHARED,
    Component: SharedPage,
  },
  {
    name: 'Followed Users',
    uri: FOLLOWING,
    Component: FollowingFeedPage,
  },
  {
    name: 'Search',
    uri: SEARCH,
    Component: SearchPage,
  },
  {
    name: 'Circles',
    uri: CIRCLES,
    Component: CirclesPage,
  },
  {
    name: 'Moderation',
    uri: MODERATION_QUEUE,
    Component: ModerationQueuePage,
  },
  {
    name: 'Edit Post Rewrite',
    uri: POST_EDIT_REWRITE,
    Component: EditRewrite,
  },
  {
    name: 'Story Analysis',
    uri: POST_ANALYSIS,
    Component: PostAnalysis,
  },
  {
    name: 'Reply Analysis',
    uri: REPLY_ANALYSIS,
    Component: ReplyAnalysis,
  },
  {
    name: 'Version History',
    uri: POST_HISTORY,
    Component: PostHistory,
  },
  {
    name: 'Sentiment Map',
    uri: POST_SENTIMENT,
    Component: SentimentMapPage,
  },
  {
    name: 'Platform Pulse',
    uri: PULSE,
    Component: PulsePage,
  },
  {
    name: 'Reputation Breakdown',
    uri: REPUTATION,
    Component: ReputationBreakdown,
  },
  {
    name: 'Vouching',
    uri: VOUCH,
    Component: VouchPage,
  },
  {
    name: 'User Manual',
    uri: README,
    Component: ManualIndex,
  },
  {
    name: 'User Manual Section',
    uri: README_SECTION,
    Component: ManualSectionRoute,
  },
];
